import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "@states/auth/auth.api";

export interface DashboardAnalytics {
    success?: boolean;
    data?: {
        net_sales: number;
        net_sales_percent: number;
        sale_order: number;
        sale_order_amount: number;
        trip_sale: number;
        trip_sale_amount: number;
        consignment: number;
        consignment_amount: number;
    };
    message?: string;
}

export interface DashboardRevenueItem {
    date: string;
    sale_order: number;
    trip_sale: number;
    consignment: number;
}

export interface DashboardRevenueResponse {
    success?: boolean;
    data?: DashboardRevenueItem[];
    message?: string;
}

export const dashboardApi = createApi({
    reducerPath: "dashboardApi",
    tagTypes: ["Dashboard"],
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getDashboardAnalytics: builder.query<DashboardAnalytics, void>({
            query: () => ({
                url: "dashboard/analytics",
            }),
        }),
        getDashboardRevenue: builder.query<DashboardRevenueResponse, void>({
            query: () => ({
                url: "dashboard/revenue",
            }),
        }),
    }),
    keepUnusedDataFor: 0,
});

export const { useGetDashboardAnalyticsQuery, useGetDashboardRevenueQuery } =
    dashboardApi;
